<div class="input-group" id="input-group-{{id}}">
    <input class="form-control w-100 customize" id="input-{{id}}" placeholder="{{placeholder}}"
        (keydown)="catchKeydown($event)" [(ngModel)]="amountText" [readonly]="readonly" (ngModelChange)="changeValue()"
        [ngClass]="{'border-red' : isError, 'otp-number': isTextAlignCenter}" />
    <span class="input-unit" *ngIf="unit">{{unit}}</span>
</div>